module.exports = __webpack_public_path__ + "img/H4.a1af00cd.png";